import React from 'react';
import { Line } from 'react-chartjs-2';

interface PerformanceRecord {
  c4: string; // 날짜 (YYYY-MM-DD)
  c26: number; // 매출액
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const OrderSalesMonthlyLineChart: React.FC<Props> = ({ records, colors }) => {
  // 월별 집계
  const monthMap: Record<string, { order: number; sales: number }> = {};
  records.forEach(rec => {
    if (!rec.c4) return;
    const month = rec.c4.slice(0, 7); // YYYY-MM
    if (!monthMap[month]) monthMap[month] = { order: 0, sales: 0 };
    monthMap[month].order += 1; // 주문수 = 레코드 개수
    monthMap[month].sales += rec.c26;
  });
  const months = Object.keys(monthMap).sort();
  const orderData = months.map(m => monthMap[m].order);
  const salesData = months.map(m => monthMap[m].sales);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Line
        data={{
          labels: months,
          datasets: [
            {
              label: '주문수',
              data: orderData,
              borderColor: colors[0] || '#8884d8',
              backgroundColor: colors[0] || '#8884d8',
              yAxisID: 'y1',
              fill: false,
              tension: 0.2,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
            {
              label: '매출액',
              data: salesData,
              borderColor: colors[1] || '#82ca9d',
              backgroundColor: colors[1] || '#82ca9d',
              yAxisID: 'y2',
              fill: false,
              tension: 0.2,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true },
            title: { display: false },
            tooltip: {
              callbacks: {
                label: function(context) {
                  if (context.dataset.label === '매출액') {
                    return `매출액: ${context.parsed.y.toLocaleString()}원`;
                  } else {
                    return `주문수: ${context.parsed.y.toLocaleString()}건`;
                  }
                }
              }
            }
          },
          scales: {
            y1: {
              type: 'linear',
              position: 'left',
              title: { display: true, text: '주문수' },
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            },
            y2: {
              type: 'linear',
              position: 'right',
              title: { display: true, text: '매출액' },
              beginAtZero: true,
              grid: { drawOnChartArea: false },
              ticks: {
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            },
            x: {
              title: { display: true, text: '월' },
            }
          }
        }}
        height={400}
      />
    </div>
  );
};

export default OrderSalesMonthlyLineChart; 